const middleware = {}

middleware['nextPage'] = require('../middleware/nextPage.ts')
middleware['nextPage'] = middleware['nextPage'].default || middleware['nextPage']

middleware['oldPage'] = require('../middleware/oldPage.ts')
middleware['oldPage'] = middleware['oldPage'].default || middleware['oldPage']

middleware['setLang'] = require('../middleware/setLang.js')
middleware['setLang'] = middleware['setLang'].default || middleware['setLang']

middleware['userIp'] = require('../middleware/userIp.ts')
middleware['userIp'] = middleware['userIp'].default || middleware['userIp']

export default middleware
